import { useEffect, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { PieChart as PieIcon } from "lucide-react";
import tr from "@/i18n/tr";
import api from "@/lib/api";

const COLORS = ["hsl(var(--brand))", "hsl(var(--info))", "hsl(var(--success))", "hsl(var(--warning))", "hsl(var(--muted-foreground))"];

export default function DistributionChart() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        (async () => {
            try {
                const now = new Date();
                const { data: r } = await api.get("/reports/monthly", { params: { year: now.getFullYear(), month: now.getMonth() + 1 } });
                const rows = (r.items || []).filter(x => (x.revenue || 0) > 0).slice(0, 5).map((x, i) => ({ name: x.customer_name || "—", value: x.revenue || 0, color: COLORS[i % COLORS.length] }));
                setData(rows);
            } catch { setData([]); }
            finally { setLoading(false); }
        })();
    }, []);
    const total = data.reduce((s, x) => s + x.value, 0);
    return (
        <div className="card-elevated p-5">
            <div className="flex items-start justify-between mb-2">
                <div>
                    <div className="text-[13px] font-semibold text-foreground">{tr.dashboard.stats.revenueDistribution}</div>
                    <div className="text-[11.5px] text-muted-foreground mt-0.5">{tr.dashboard.stats.thisMonthShare}</div>
                </div>
            </div>
            {loading ? (
                <div className="h-40 flex items-center justify-center text-[12px] text-muted-foreground">Yükleniyor…</div>
            ) : data.length === 0 ? (
                <div className="h-40 flex flex-col items-center justify-center text-muted-foreground"><PieIcon className="h-7 w-7 opacity-30 mb-1" /><div className="text-[12px]">Bu ay için gelir kaydı yok.</div></div>
            ) : (
                <div className="grid grid-cols-2 items-center gap-4 mt-2">
                    <div className="relative h-40">
                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                                <Pie data={data} dataKey="value" innerRadius={44} outerRadius={64} paddingAngle={2}>
                                    {data.map((e, i) => <Cell key={i} fill={e.color} />)}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>
                    </div>
                    <ul className="space-y-1.5 text-[11.5px]">
                        {data.map((e) => (
                            <li key={e.name} className="flex items-center gap-2">
                                <span className="h-2 w-2 rounded-full shrink-0" style={{ background: e.color }} />
                                <span className="flex-1 truncate">{e.name}</span>
                                <span className="font-semibold tabular-nums">%{Math.round((e.value / total) * 100)}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
